import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";

const SHUGERT_PRO_INTAKE = "https://shugert.pro/admin/intake";

export const Route = createFileRoute("/admin/opportunities")({
  head: () => ({
    meta: [
      { title: "Commercial Intake moved · Shugert Admin" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: CommercialIntakeRedirect,
});

function CommercialIntakeRedirect() {
  useEffect(() => {
    window.location.replace(SHUGERT_PRO_INTAKE);
  }, []);

  return (
    <main style={{ padding: "2rem" }}>
      <h1>Opportunities moved to Shugert.pro</h1>
      <p>Commercial opportunities are now managed centrally in Shugert.pro.</p>
      <p><a href={SHUGERT_PRO_INTAKE}>Open Commercial Intake</a></p>
    </main>
  );
}
